import React from "react";
import { Checkbox } from "antd";
import styled from "styled-components";
import { IOption } from "components/select/Select";

interface ICheckboxItem {
  value?: string | number;
  key?: number;
  name?: string;
}

interface ICheckbox {
  row?: boolean;
  onChange?: (e: any) => void;
  list?: ICheckboxItem[];
  defaultValue?: string[];
  value?: string[];
  gap?: string;
}

const CheckboxStyled = styled(Checkbox)(({ theme }) => ({
  alignItems: "unset",
  outline: "none",
  "&:hover": {
    ".ant-checkbox-inner": {
      borderColor: theme.colors.border,
    },
  },
  ".ant-checkbox": {
    top: "unset",
  },
  ".ant-checkbox-inner": {
    width: 20,
    height: 21,
    border: `2px solid ${theme.colors.border}`,
  },
  ".ant-checkbox-checked .ant-checkbox-inner": {
    backgroundColor: theme.colors.button,
    borderColor: `${theme.colors.button}!important`,
  },
  ".ant-checkbox-checked::after": {
    border: "none",
  },
  ".ant-checkbox-input:focus + .ant-checkbox-inner": {
    borderColor: theme.colors.border,
  },
  ".ant-checkbox + span": {
    paddingTop: 3,
    paddingRight: 0,
  },
}));

const CheckboxCustom2: React.FC<ICheckbox> = ({
  row,
  list,
  onChange,
  defaultValue,
  value,
  gap,
}) => {
  const styles: any = row
    ? { display: "flex", gap: gap || "16px", flexWrap: "wrap" }
    : "";
  const spaceItem = row ? {} : { marginBottom: 12 };
  return (
    <Checkbox.Group
      style={{ width: "100%" }}
      onChange={onChange}
      defaultValue={defaultValue}
      value={value}
    >
      <div style={{ ...styles }}>
        {(list || []).map((item) => (
          <div key={item.key} style={{ ...spaceItem }}>
            <CheckboxStyled key={item.key} value={item.value}>
              {item.name}
            </CheckboxStyled>
          </div>
        ))}
      </div>
    </Checkbox.Group>
  );
};

export default CheckboxCustom2;
